<template>
  <RemotePaginatedList :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       v-model="selectedItemIds"
                       data-url="admin/user/contract_user/"
                       :extra-params="{user_id: userId}"
                       data-key="contract_users"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs"
                       hide-default-footer
                       class="user-contract-list">
    <template #item.status="{value}">
      <span :class="['admin-status-span', value]">
        {{ value }}
        <div class="admin-status-dot"></div>
      </span>

    </template>
    <template #item.updated_at="{value}">
      {{ $parseDate(value) }}
    </template>
    <template v-slot:item.actions="{item}">
      <div class="d-flex">
        <v-btn text
               color="primary"
               v-if="item.status === 'PENDING' || item.status === 'DECLINED'"
               @click="approveItem(item)">
          APPROVE
        </v-btn>
        <v-btn text
               color="primary"
               v-if="item.status === 'PENDING' || item.status === 'APPROVED'"
               @click="declineItem(item)">
          DECLINE
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'UserContractUserList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    refreshTrigger: Boolean,

    userId: String,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh(true);
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = ref([])

    // Data Table
    const headers = ref([
      {text: root.$t('contract_user.status'), value: 'status', width: 150},
      {text: root.$t('contract.name'), value: 'contract.name'},
      // {text: '', value: 'actions', sortable: false, width: 250},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });
    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({text: root.$t('contract_user.delete_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/contract/user/delete/',
          params: {year_id: item.id},
        })

        if (response.body.success) {
          await refresh();
        }
      }
    }
    const approveItem = async function (item) {
      if (await root.$dialog.confirm({text: root.$t('contract_user.approve_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/contract/user/approve/',
          params: {contract_user_id: item.id},
        })

        if (response.body.success) {
          await refresh();
        }
      }
    };
    const declineItem = async function (item) {
      if (await root.$dialog.confirm({text: root.$t('contract_user.decline_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/contract/user/decline/',
          params: {contract_user_id: item.id},
        })

        if (response.body.success) {
          await refresh();
        }
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      deleteItem,
      approveItem,
      declineItem,
    }
  }
}
</script>

<style lang="less">
.user-contract-list {
  .admin-status-span {
    .admin-status-dot {
      height: 10px;
      width: 10px;
      border-radius: 10px;
      display: inline-block;
    }

    &.DECLINED {
      color: #EF3924;

      .admin-status-dot {
        background-color: #EF3924;
      }
    }

    &.PENDING {
      color: #D4A106;

      .admin-status-dot {
        background-color: #D4A106;
      }
    }

    &.APPROVED {
      color: #5BC23F;

      .admin-status-dot {
        background-color: #5BC23F;
      }
    }
  }
}
</style>
